import React from "react"
import { Home } from "../components/main/Home"
import { Stagione } from "../components/main/Stagione"

export class Router {
    public static getBaseUrl = () => process.env.PUBLIC_URL.endsWith("/") ? process.env.PUBLIC_URL : process.env.PUBLIC_URL + "/"

    public static readonly SEASON_BASE_URL = "season/"
    public static readonly SEASON_URL = this.SEASON_BASE_URL + ":id"

    private static readonly PAGES = new Map<string | string[], React.ComponentClass<any>>([
        [this.getBaseUrl(), Home],
        [this.getBaseUrl() + this.SEASON_URL, Stagione]
    ])

    public static getPage = (url: string) => {
        let page: React.ComponentClass
        let urlToGet = url

        page = this.PAGES.get(urlToGet)

        if (!page) {
            const pieces = url.split("/"),
            rebuildUrl = pieces.filter((_, i) => i < pieces.length - 1).join("/")
            urlToGet = rebuildUrl + "/:id"
        }

        page = this.PAGES.get(urlToGet)

        if (!page) {
            Array.from(this.PAGES.keys()).forEach(key => {
                if(Array.isArray(key) && (key.includes(urlToGet) || key.includes(url)))
                    page = this.PAGES.get(key)
            })
        }

        if(!page)
            return React.Fragment

        return page
    }

    public static getPathParams = () => {
        const url = window.location.pathname,
            pieces = url.split("/")

        if (this.PAGES.has(this.getWindowUrl()) || Array.from(this.PAGES.keys()).some(k => Array.isArray(k) && k.includes(url)))
            return {}

        return { id: pieces[pieces.length - 1] }
    }

    public static getWindowUrl = () => this.polishUrl((window.location.pathname.substring(this.getBaseUrl().length, window.location.pathname.length)) || "")

    public static polishUrl = (url: string) => {
        const baseUrl = url.endsWith("/") ? url : url + "/"

        return baseUrl.split("#")[0]
    }

    public static isUrl = (url: string) => {
        const polished = url === this.getBaseUrl() ? url : this.getBaseUrl() + url
        return this.polishUrl(window.location.pathname) === polished || window.location.pathname === polished
    }
}